/**
 * 订单排序方法
 */
enum OrderSort {
    /** 下单时间降序 */
    ORDER_TIME_DESC = "ORDER_TIME_DESC",

    /** 下单时间升序 */
    ORDER_TIME_ASC = "ORDER_TIME_ASC",

    /** 订单导入时间（手工订单） */
    IMPORT = "IMPORT",

    /** 付款时间 升序 */
    PAY_TIME_ASC = "PAY_TIME_ASC",

    /** 付款时间（降序）*/
    PAY_TIME_DESC = "PAY_TIME_DESC",

    /** 商品信息 */
    ORDER_ITEMS = "ORDER_ITEMS",

    /** 商品颜色尺码 */
    PRODUCT_SKU_COLOR_SIZE = "PRODUCT_SKU_COLOR_SIZE",

    /** 付款金额(desc) */
    PAYMENT_AMOUNT_DESC = "PAYMENT_AMOUNT_DESC",

    /** 发货时间 升序 */
    SHIP_TIME_ASC = "SHIP_TIME_ASC",

    /** 发货时间(降序) */
    SHIP_TIME_DESC = "SHIP_TIME_DESC",

    /** 打印序号 */
    SEQUENCE_NO = "SEQUENCE_NO",

    /* 最后发货时间升序 */
    LAST_SHIPPING_TIME_ASC = "LAST_SHIPPING_TIME_ASC",

    /* 承诺发货时间升序 */
    PROMISE_SHIPPING_TIME_ASC = "PROMISE_SHIPPING_TIME_ASC",

    /**  相同买家昵称排一起 */
    BUYER_NICKNAME = "BUYER_NICKNAME",

    /** 按商品数量：数量小在前  */
    ORDER_ITEM_QUANTITY = "ORDER_ITEM_QUANTITY",
    /** 按商品数量：数量大在前  */
    ORDER_ITEM_QUANTITY_DESC = "ORDER_ITEM_QUANTITY_DESC ",
    /** 按订单重量：重量小在前 */
    ORDER_WEIGHT = "ORDER_WEIGHT",
    /** 按省市区排序 */
    ORDER_CONSIGNEE_REGION = "ORDER_CONSIGNEE_REGION",
    /** 按规格简称规格/名称排序 */
    SIMPLE_TITLE_OTHERWISE_SKU_PROPERTIES = "SIMPLE_TITLE_OTHERWISE_SKU_PROPERTIES",
    /** 按商品编码排序 */
    PRODUCT_SKU_EXTERNAL_ID = "PRODUCT_SKU_EXTERNAL_ID",
    /** 按规格编码排序 */
    SKU_EXTERNAL_ID = "SKU_EXTERNAL_ID",

    /** 按异常生成时间降序排序 */
    ABNORMAL_RECORD_TIME_DESC = "ABNORMAL_RECORD_TIME_DESC",
    /** 按异常生成时间升序排序 */
    ABNORMAL_RECORD_TIME_ASC = "ABNORMAL_RECORD_TIME_ASC",
}

export default OrderSort;
